import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { ReporteGeneralService } from '../../services/reporte-general.service';


@Component({
  selector: 'app-reporte-liquidacion-comprobante-imagen',
  templateUrl: './reporte-liquidacion-comprobante-imagen.component.html',
  styleUrls: ['./reporte-liquidacion-comprobante-imagen.component.scss']
})
export class ReporteLiquidacionComprobanteImagenComponent implements OnInit {

  public comprobanteImage:any;
  public hash:any;


  constructor(
    private reporteGeneralService: ReporteGeneralService, private sanitizer: DomSanitizer,
    private route: ActivatedRoute,private router: Router) {

  }

  ngOnInit() {
    this.getImageComprobante();
  }

  getImageComprobante() {
    this.hash = this.route.snapshot.queryParams["hash"];
    //this.loadFotografias(this.hash);
    this.navigateToFile(this.hash);
  }

  loadFotografias(data) {
      this.reporteGeneralService.getReporteImagenComprobante(data).subscribe(response => {
        const unsave_url = window.URL.createObjectURL(response.blob());
        this.comprobanteImage = this.sanitizer.bypassSecurityTrustUrl(unsave_url);
      });
  }

  navigateToFile(data){
    var url = this.reporteGeneralService.getReporteImagenComprobanteAsURL(data);
    window.location.href = url;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/reporte-liquidacion-comprobante-imagen/reporte-liquidacion-comprobante-imagen.component.ts